import Loader from "Components/Loading/Loader/Loader";
import TaskTemplatePageConstants from "Constants/TaskTemplatePageConstants";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateAction } from "Store/TaskTemplates/TaskTemplateAction";
import { TaskTemplateFilterState } from "Store/TaskTemplates/TaskTemplateFilterState";
import i18n from "Translations/i18n";
import TaskTemplateBlockCard from "./TaskTemplateBlockCard/TaskTemplateBlockCard";
import styles from "./TaskTemplateBlockView.scss";

const taskTemplateAction = ServiceProvider.get<ITaskTemplateAction>(Types.ITaskTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getTaskTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(taskTemplateAction.getTaskTemplatesByFilterAsync(filter)),
});

const mapStateToProps = (state: IApplicationState) => ({
    isLoading: state.taskTemplateState.isLoading,
    totalTasks: state.taskTemplateState.totalTasks,
    taskTemplates: state.taskTemplateState.taskTemplates,
    currentFilter: state.taskTemplateState.currentFilter,
    skip: (state.taskTemplateState.currentFilter && state.taskTemplateState.currentFilter.skip) || 0
});

interface IProps {
    isLoading: boolean;
    totalTasks?: number;
    taskTemplates?: TaskTemplate[];
    currentFilter: TaskTemplateFilterState;
    skip: number;
    getTaskTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

export class TaskTemplateBlockView extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.loadMore = this.loadMore.bind(this);
    }

    public componentDidMount() {
        this.loadTaskTemplates(0);
    }

    private loadTaskTemplates(skip: number) {
        const filter = {
            ...this.props.currentFilter,
            skip,
            take: TaskTemplatePageConstants.BLOCK_ITEMS_PER_PAGE
        };
        this.props.getTaskTemplatesByFilterAsync(filter);
    }

    public loadMore() {
        if (!this.props.isLoading) {
            const skip = this.props.skip;
            const totalTasks = this.props.totalTasks;
            const itemsOnPage = this.props.taskTemplates!.length;

            if (skip + TaskTemplatePageConstants.BLOCK_ITEMS_PER_PAGE < totalTasks! && skip < itemsOnPage) {
                const newSkip = skip + TaskTemplatePageConstants.BLOCK_ITEMS_PER_PAGE;

                if (newSkip !== skip) {
                    this.loadTaskTemplates(newSkip);
                }
            }
        }
    }

    public render() {
        return (
            <div className={styles.taskTemplateBlockView}>
                {
                    (this.props.taskTemplates && this.props.totalTasks) ? (
                        <InfiniteScroll
                            id="infiniteScroll"
                            pageStart={0}
                            loadMore={this.loadMore}
                            hasMore={this.props.totalTasks > this.props.taskTemplates.length}
                            loader={<div className="loader" key={0}>Loading ...</div>}>
                            <div className={styles.overviewHeader}>
                                <div className={styles.numResults}>{this.props.totalTasks} results</div>
                            </div>
                            <div className={styles.list}>
                                {this.props.taskTemplates.map(taskTemplate => <TaskTemplateBlockCard key={taskTemplate.id} taskTemplate={taskTemplate} />)}
                            </div>
                        </InfiniteScroll>
                    ) : (this.props.isLoading) ? (<Loader />) : (<span id="spanNoTaskTemplatesFound">{i18n.t("tasks.noTasksFound")}</span>)
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateBlockView);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockView.tsx